import "./style.css";

export default class Media {
  static selector = ".media";

  constructor(block) {
    this.block = block;

    this.video = block.querySelector("video");

    this.playButton = block.querySelector("button");
  }

  onClick = () => {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
    this.video.classList.toggle("playing", !this.video.paused);
    this.playButton.classList.toggle("no-display", !this.video.paused);
  };

  onReady = () => {
    if (this.video) {
      this.video.addEventListener("click", this.onClick);
    }

    if (this.playButton) {
      this.playButton.addEventListener("click", this.onClick);
    }
  };

  onDestroy = () => {
    if (this.video) {
      this.video.removeEventListener("click", this.onClick);
    }

    if (this.playButton) {
      this.playButton.removeEventListener("click", this.onClick);
    }
  };
}
